export var getKeyByValue = function (value, enumObj) {
    for (var key in enumObj) {
        if (enumObj[key] === value) {
            return key;
        }
    }
};
